type Primitive = string | number | symbol | undefined;

type MatchPattern<T extends Primitive> = {
  [K in Exclude<T, undefined>]?: (() => any) | any;
} & {
  undefined?: (() => any) | any;
  _?: (() => any) | any;
};

type ExtractReturnType<P> = P[keyof P] extends (...args: any) => any
  ? ReturnType<P[keyof P]>
  : never;

export function match<T extends Primitive, P extends MatchPattern<T>>(
  value: T,
  pattern: P,
): ExtractReturnType<P> {
  if (value === undefined && pattern.undefined) {
    return pattern.undefined();
  }

  if (value && value in pattern) {
    const fn = pattern[value as keyof P];
    if (typeof fn === "function") {
      return fn();
    }
    return fn;
  }

  if ("_" in pattern && pattern._) {
    const fn = pattern["_"];
    if (typeof fn === "function") {
      return fn();
    }
    return fn;
  }

  throw new Error(
    `Non-exhaustive match: no handler for value "${String(value)}"`,
  );
}
